import { useState } from "react";
import { useMutation } from "@tanstack/react-query";
import { PlayPracticeGameDto } from "@nestcoinco/hyper-api-gateway-api-client";
import { useSetAtom } from "jotai";
import { useNavigate } from "react-router-dom";

import { QUERY_KEYS } from "../constants";
// NOTE: There is no dedicated "solo game" endpoint; solo games intentionally
// reuse the practice-game endpoint, which is why we alias this import here.
import { handlePlayPracticeGame as handlePlaySoloGame } from "../../api-clients/tournamentsDefaultClient";
import { GameFlowState, GameType } from "../../utils/constants";
import {
  gameTypeAtom,
  gameFlowStateAtomWithStorage,
} from "../../jotai/atoms/games";
import { practiceGameEntryAtom as soloGameEntryAtom } from "../../jotai/atoms/tournament";
import { ROUTES } from "../../utils/constants";
import useAnalytics from "../../hooks/useAnalytics";

function usePlaySoloGameMutation(
  dto?: PlayPracticeGameDto,
  redirectUrl?: string,
  skipNavigation?: boolean
) {
  const navigate = useNavigate();
  const analytics = useAnalytics();
  const setSoloGameEntry = useSetAtom(soloGameEntryAtom);
  const setGameType = useSetAtom(gameTypeAtom);
  const setGameFlowState = useSetAtom(gameFlowStateAtomWithStorage);
  const [gameUrl, setGameUrl] = useState<string>();

  const mutation = useMutation({
    mutationKey: [QUERY_KEYS.TOURNAMENT.PLAY_SOLO_GAME],
    mutationFn: () => handlePlaySoloGame(dto),
    onSuccess: (entry) => {
      const { name: gameName, slug: gameSlug } = entry.game;
      analytics.sendInitiateGameEvent({
        entry_fee: 0,
        game_name: gameName,
        game_mode: GameType.SOLO,
      });
      setSoloGameEntry(entry);
      setGameType(GameType.SOLO);
      setGameFlowState(GameFlowState.STARTING_GAME);

      if (skipNavigation) {
        setGameUrl(entry.gamePlayUrl);
      } else {
        const url =
          redirectUrl ||
          `${ROUTES.GAMES.ROOT}/${gameSlug}${ROUTES.ROOT.SOLO_GAME}`;
        navigate(url);
      }
    },
  });

  return {
    mutation,
    gameUrl,
    isPending: mutation.isPending,
  };
}

export default usePlaySoloGameMutation;
